import { useT } from "~/util/Lang";
import { priceFormat } from "./Price";

export function CrystalName(props: { type: string }) {
  const t = useT();
  const crystalType = props.type;

  return (
    <>
      {t({
        en:
          crystalType === "none"
            ? "Crystal: No Grade"
            : `Crystal: ${crystalType?.toUpperCase()}-Grade`,
        ru:
          crystalType === "none"
            ? "Кристалл: Без ранга"
            : `Кристалл: ${crystalType?.toUpperCase()}-Ранг`,
      })}
    </>
  );
}

export function CrystalValue(props: { type: string; value: string | number }) {
  return (
    <span style={{ color: getColor(props.type) }}>
      {priceFormat(props.value)}
    </span>
  );
}

export function CrystalColor(type: string) {
  return getColor(type);
}

function getName(type: string) {
  switch (type.toLocaleLowerCase()) {
    case "d":
      return "Crystal: D Grade";
    case "c":
      return "Crystal: C Grade";
    case "b":
      return "Crystal: B Grade";
    case "a":
      return "Crystal: A Grade";
    case "s":
      return "Crystal: S Grade";
    case "s80":
      return "Crystal: S Grade";
    case "s84":
      return "Crystal: S Grade";
    default:
      return "None";
  }
}

function getColor(type: string) {
  switch (type) {
    case "d":
      return "#9999FF";
    case "c":
      return "#00CC00";
    case "b":
      return "#FF6666";
    case "a":
      return "#999999";
    case "s":
      return "#ffef66";
    case "s80":
      return "#ffef66";
    case "s84":
      return "#ffef66";
    default:
      return "#999";
  }
}

function getIcon(type: string) {
  switch (type) {
    case "d":
      return "/s/icons/etc_crystal_blue_i00.png";
    case "c":
      return "/s/icons/etc_crystal_green_i00.png";
    case "b":
      return "/s/icons/etc_crystal_red_i00.png";
    case "a":
      return "/s/icons/etc_crystal_silver_i00.png";
    case "s":
      return "/s/icons/etc_crystal_gold_i00.png";
    default:
      return "/s/icons/etc_crystal_blue_i00.png";
  }
}
